import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { setUnauthorizedHandler } from './services/http/httpClient'
import { useAuthStore } from './stores/auth.store'
import { usePlatformAuthStore } from './stores/platformAuth.store'
import './plugins/dayjs'
import 'ant-design-vue/dist/reset.css'
import './assets/styles/global.css'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// A rejected token ends the session everywhere, not just for the failed request.
setUnauthorizedHandler((kind) => {
  if (kind === 'platform') {
    const platformAuth = usePlatformAuthStore(pinia)
    if (!platformAuth.isAuthenticated) return
    platformAuth.forgetSession()
    router.push({ name: 'platform-login' })
    return
  }

  const auth = useAuthStore(pinia)
  if (!auth.isAuthenticated) return
  auth.forgetSession()
  const redirect = router.currentRoute.value.fullPath
  router.push({ name: 'login', query: redirect.startsWith('/autentificare') ? undefined : { redirect } })
})

createApp(App).use(pinia).use(router).mount('#app')
